import { CardholderUserService } from './../../services/cardholder-user.service';
import { CardholderDetails } from './../../data/CardholderDetails';
import { CardholderService } from './../../services/cardholder.service';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { Transaction } from './../../data/Transaction';
import { CustomerAccount } from './../../data/CustomerAccount';
import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { TransactionInfo } from 'src/app/data/TransactionInfo';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import {ProfileSearchResult} from "../../data/ProfileSearchResult";

@Component({
  selector: 'app-cardholder-open-loop-history',
  templateUrl: './cardholder-open-loop-history.component.html',
  styleUrls: ['./cardholder-open-loop-history.component.css']
})
export class CardholderOpenLoopHistoryComponent implements OnInit {
  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private cardholderService: CardholderService,
    private cardholderUserService: CardholderUserService,
    private messageService: MessageService
  ) {}
  cardholderDetails: CardholderDetails;
  stripAccount: CustomerAccount;
  visaBalance = '';
  selectedPage = 1;
  itemsPerPage = 25;
  customerAccounts: CustomerAccount[];
  pagedResults: Transaction[];
  transactions: Transaction[] = [];
  search_btn_spinner: string;
  loading: boolean;
  transactionDateRange = 35; // This should reflex what is in TransactionController.java
  startDate: NgbDate;
  endDate: NgbDate;
  cardholder: ProfileSearchResult;
  account: number;

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }

  ngOnInit() {
    this.endDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.fetchCardholderAccountDetails();
  }

  fetchCardholderAccountDetails() {
    this.loading = true; // This will get set to false in fetchTransactionData()
    const that = this;
    this.cardholder = CardholderService.retrieveCardholder();
    if (this.cardholder != null) {
      this.cardholderUserService.getCardholderDetails(this.cardholder.cardNum).subscribe(
        data => {
          this.cardholderDetails = data;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            }
          });
        },
        error => {
          this.messageService.error(error.error);
          this.loading = false;
        }
      );
    }
    else {
      this.cardholderUserService.getCardholderDetails().subscribe(
        data => {
          this.cardholderDetails = data;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            }
          });
        },
        error => {
          this.messageService.error(error.error);
          this.loading = false;
        }
      );
    }

  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  pageSet(page) {
    this.selectedPage = page;
    this.setPagedResults();
  }

  setPagedResults() {
    if (this.transactions.length <= 10) {
      this.pagedResults = this.transactions;
    } else {
      this.pagedResults = this.transactions.slice(
        (this.selectedPage - 1) * this.itemsPerPage,
        (this.selectedPage - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }
}
